import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import logoDarkTheme from '../../../assets/images/advran-logo-white.png';
import logoLightTheme from '../../../assets/images/advran-logo.png';
import Config from '../../../constants/Config';
import { Themes } from '../../../constants/Enums';

import * as sShared from '../SettingsShared.module.scss';
import * as s from './AboutSettings.module.scss';

const AboutSettings = React.memo(({ demoMode, theme }) => {
  const [t] = useTranslation();

  return (
    <div className={sShared.wrapper}>
      <div className={sShared.header}>
        <h2 className={sShared.headerText}>{t('common.about')}</h2>
      </div>
      <div>
        <img src={theme === Themes.LIGHT ? logoLightTheme : logoDarkTheme} className={s.logo} alt="Advran" />
        <div className={s.version}>
          {t('common.version')} {Config.VERSION}
        </div>
        {demoMode && <div className={s.demoMode}>{t('common.demoMode')}</div>}
      </div>
    </div>
  );
});

AboutSettings.propTypes = {
  demoMode: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired,
};

export default AboutSettings;
